// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "./Search.css";

// export default function Search() {
//   const [query, setQuery] = useState("");
//   const navigate = useNavigate();

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (query.trim()) {
//       navigate(`/search?query=${encodeURIComponent(query)}`);
//       setQuery("");
//     }
//   };

//   return (
//     <div className="search-wrapper ms-md-3 my-2 mx-3 my-md-0">
//       <form onSubmit={handleSubmit} className="position-relative">
//         <i className="bi bi-search search-icon"></i>
//         <input
//           type="search"
//           className="form-control search-input ps-5"
//           placeholder="Search courses..."
//           value={query}
//           onChange={(e) => setQuery(e.target.value)}
//         />
//       </form>
//     </div>
//   );
// }

import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Search.css";

export default function Search() {
  const navigate = useNavigate();
  const wrapperRef = useRef(null);

  const [query, setQuery] = useState("");
  const [courses, setCourses] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  /* ================= FETCH COURSES ================= */
  useEffect(() => {
    setLoading(true);
    fetch("https://agepcoatings.com/getcourses")
      .then((res) => res.json())
      .then((data) => {
        setCourses(Array.isArray(data) ? data : []);
      })
      .finally(() => setLoading(false));
  }, []);

  /* ================= CLOSE DROPDOWN ON OUTSIDE CLICK ================= */
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  /* ================= SEARCH LOGIC ================= */
  const results = useMemo(() => {
    if (!query.trim()) return [];

    const words = query.toLowerCase().split(" ").filter(Boolean);

    return courses
      .map((course) => {
        const courseText = `
          ${course.courseName}
          ${course.courseDescription}
          ${course.badge}
        `.toLowerCase();

        const matchedLevels = Array.isArray(course.levelsData)
          ? course.levelsData.filter((level) => {
              const levelText = `
                ${level.levelName}
                ${level.levelDescription}
                ${level.levelbadge}
              `.toLowerCase();

              return words.every((w) => levelText.includes(w));
            })
          : [];

        const courseMatch = words.every((w) =>
          courseText.includes(w)
        );

        if (courseMatch || matchedLevels.length > 0) {
          return {
            ...course,
            matchedLevels: courseMatch
              ? course.levelsData
              : matchedLevels,
          };
        }

        return null;
      })
      .filter(Boolean);
  }, [courses, query]);

  /* ================= NAVIGATION HANDLERS ================= */
  const goToCourse = (courseId) => {
    setOpen(false);
    setQuery("");
    navigate(`/courses/${courseId}`);
  };

  const goToLevel = (courseId, levelId) => {
    setOpen(false);
    setQuery("");
    navigate(`/courses/${courseId}`, {
      state: { scrollToLevel: levelId },
    });
  };

  /* ================= UI ================= */
  return (
    <div
      ref={wrapperRef}
      className="search-wrapper ms-md-3 my-2 mx-3 my-md-0 position-relative"
    >
      <div className="position-relative">
        <i className="bi bi-search search-icon"></i>
        <input
          type="search"
          className="form-control search-input ps-5"
          placeholder="Search courses"
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
            setOpen(true);
          }}
          autoComplete="off"
        />
      </div>

      {/* ================= DROPDOWN ================= */}
      {open && query && (
        <div className="search-results-dropdown">
          {loading && <div className="p-3">Loading…</div>}

          {!loading && results.length === 0 && (
            <div className="p-3 text-muted">
              No courses or levels found
            </div>
          )}

          {!loading &&
            results.map((course) => (
              <div key={course.courseId} className="search-result-item">
                {/* COURSE */}
                <div
                  className="fw-bold course-result"
                  onClick={() => goToCourse(course.courseId)}
                >
                  {course.courseName}
                </div>

                {/* LEVELS */}
                {course.matchedLevels?.length > 0 && (
                  <ul className="small ps-3 mb-0">
                    {course.matchedLevels.map((lvl) => (
                      <li
                        key={lvl.levelId}
                        className="level-result"
                        onClick={() =>
                          goToLevel(course.courseId, lvl.levelId)
                        }
                      >
                        {lvl.levelName}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
        </div>
      )}
    </div>
  );
}
